import React, { useMemo } from 'react';
import { DeleteForever, Edit } from '@mui/icons-material';
import { IDataTable } from '@shared/models/data-table.model';
import { useDeleteDataTable } from './store';
import { openDataTableDialog } from './dialog/data-table-dialog.store';
import { KebabMenuProps, KebabMenu } from '@ui/menus/KebabMenu';

interface DataTableKebabMenuProps extends KebabMenuProps {
  dataTable: IDataTable;
}

export const DataTableKebabMenu: React.FC<DataTableKebabMenuProps> = ({
  dataTable,
  onClose,
  ...props
}) => {
  const deleteDataTable = useDeleteDataTable();

  const handleEdit = useMemo(
    () => () => {
      openDataTableDialog(dataTable);
      onClose?.();
    },
    [dataTable, onClose],
  );

  const handleDelete = useMemo(
    () => async () => {
      await deleteDataTable(dataTable.id, dataTable.name);
      onClose?.();
    },
    [deleteDataTable, dataTable.id, dataTable.name, onClose],
  );

  const items = useMemo(
    () => [
      {
        id: 'edit',
        label: 'Edit',
        icon: <Edit color="secondary" />,
        onClick: handleEdit,
      },
      {
        id: 'delete',
        label: 'Delete',
        icon: <DeleteForever color="secondary" />,
        onClick: handleDelete,
      },
    ],
    [handleEdit, handleDelete],
  );

  return (
    <KebabMenu id={dataTable.id} items={items} onClose={onClose} {...props} />
  );
};
